import { useEffect, useRef, useState } from "react";
import { refreshRadar } from "../lib/api";

export function RadarControls({ onReload }: { onReload: () => void }) {
  const [token, setToken] = useState(() => sessionStorage.getItem("lobster-operator-token") ?? "");
  const [scanning, setScanning] = useState(false);
  const [message, setMessage] = useState("");
  const stop = useRef(false);
  useEffect(() => () => { stop.current = true; }, []);
  async function scan() {
    sessionStorage.setItem("lobster-operator-token", token.trim());
    stop.current = false; setScanning(true); let offset: number | null = 0; let accepted = 0; let failures = 0;
    try {
      while (offset !== null && !stop.current) {
        setMessage(`Checking employers ${offset + 1}–${offset + 4} of 140…`);
        const result = await refreshRadar(offset, token.trim());
        accepted += result.data.jobsAccepted; failures += result.data.sourceFailures;
        offset = result.nextOffset;
        onReload();
      }
      setMessage(`${stop.current ? "Stopped" : "Scan complete"}: ${accepted} accepted observations, ${failures} source failures.`);
    } catch (error) { setMessage(error instanceof Error ? error.message : "Scan failed."); }
    finally { setScanning(false); onReload(); }
  }
  return <details className="scan-controls" onToggle={event => { if (event.currentTarget.open) setToken(sessionStorage.getItem("lobster-operator-token") ?? ""); }}><summary>Scan / connect</summary><div>
    <label>Operator token<input type="password" autoComplete="off" value={token} onChange={e => setToken(e.target.value)} /></label>
    <p>Use your production operator token on the live site. The development token works only with the local backend.</p>
    <button onClick={() => { sessionStorage.setItem("lobster-operator-token", token.trim()); onReload(); }}>Connect / reload</button>
    <button disabled={scanning} onClick={() => void scan()}>Scan 140 employers</button>
    {scanning && <button onClick={() => { stop.current = true; setMessage("Stopping after the current four employers…"); }}>Stop scan</button>}
    <p role="status">{message}</p>
  </div></details>;
}
